"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldError = exports.FormMode = void 0;
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const react_1 = require("react");
var FormMode;
(function (FormMode) {
    FormMode["View"] = "view";
    FormMode["Edit"] = "edit";
})(FormMode = exports.FormMode || (exports.FormMode = {}));
const useFieldError = (name) => {
    const { submitCount, touched, errors } = formik_1.useFormikContext();
    const fieldTouch = react_1.useMemo(() => lodash_1.get(touched, name), [name, touched]);
    const fieldError = react_1.useMemo(() => lodash_1.get(errors, name), [name, errors]);
    return react_1.useMemo(() => (submitCount > 0 || fieldTouch) && fieldError, [fieldTouch, fieldError, submitCount]);
};
exports.useFieldError = useFieldError;
//# sourceMappingURL=utils.js.map